import { MediaType } from "@jconradi/tutu-porn-api-client/src/media";
import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users";
import { BunnyCdnImage } from "../../Image/BunnyCdnImage";
import { Transcoding } from "../Transcoding/Transcoding";
import { VideoPlayer } from "../Video/VideoPlayer";

export interface GalleryItemProps {
    media: MediaListItem;
    [rest: string]: any;
};
export const GalleryItem = ({ media, ...rest }: GalleryItemProps) => {
    if (media.isTranscoding) {
        return <Transcoding />
    }
    if (media.mediaType === MediaType.Photo) {
        return (
            <BunnyCdnImage loading="eager" fill={true}  key={media.slug} className="object-contain w-full h-full"  
            src={media.urls.poster!} alt={`Photo for ${media.slug}`}
            {...rest} />
        )
    }

    if (media.mediaType === MediaType.Video) {
        return (
            <VideoPlayer media={media} autoPlayInView={true}  />
        )
    }

    return null;
}